// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const buscarEmpreendimentosService = async () => {
  const token = validateToken();
  const URL = `${Globais.DOMINIOBACK}/empreendimento/system`;
  try {
    const response = await axios.get(URL, {
      headers: token ? { Authorization: token.AuthStr } : undefined,
    });
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};
